export default {
    "data": {
        "h5": {
            "imgObj": {
                "top": "https://s21.lgstatic.com/growth/activity/20220315/1647312239637.png",
                "icon": "https://s20.lgstatic.com/growth/activity/20210830/1630295757727.png",
                "btn1": "https://s20.lgstatic.com/growth/activity/20210910/1631244324453.png",
                "btn2": "https://s21.lgstatic.com/growth/activity/20210910/1631255366492.png",
                "btn3": "https://s21.lgstatic.com/growth/activity/20210910/1631257106275.png",
                "section1": "https://s21.lgstatic.com/growth/activity/20210910/1631256414150.png",
                "section2": "https://s21.lgstatic.com/growth/activity/20210910/1631258471830.png",
                "footer": "https://s21.lgstatic.com/growth/activity/20220426/1650954257966.png",
            },
            "imgList": [
                "https://s21.lgstatic.com/growth/activity/20220607/1654584525773.png",
                "https://s21.lgstatic.com/growth/activity/20220607/1654584588406.png",
                "https://s21.lgstatic.com/growth/activity/20210910/1631243948948.png",
                "https://s20.lgstatic.com/growth/activity/20210910/1631244707482.png",
                "https://s20.lgstatic.com/growth/activity/20210910/1631244721052.png",
                "https://s21.lgstatic.com/growth/activity/20210910/1631244729899.png"
            ],
            "imgList1": [
                "https://s20.lgstatic.com/growth/activity/20210910/1631257252118.png",
                "https://s20.lgstatic.com/growth/activity/20210913/1631520978855.png",
                // "https://s21.lgstatic.com/growth/activity/20210910/1631257266038.png",
                "https://s20.lgstatic.com/growth/activity/20220315/1647312271286.png"
            ],
            "imgtabList": [
                "https://s20.lgstatic.com/growth/activity/20220607/1654599011025.png",
                "https://s21.lgstatic.com/growth/activity/20220607/1654597821649.png"
            ],
            "swiperList": [
                {
                    "imgUrl": "https://s20.lgstatic.com/growth/activity/20210910/1631257901120.png",
                    "storyImg": "https://s21.lgstatic.com/growth/activity/20210910/1631257914692.png"
                }, {
                    "imgUrl": "https://s21.lgstatic.com/growth/activity/20210910/1631257937108.png",
                    "storyImg": "https://s21.lgstatic.com/growth/activity/20210910/1631257947278.png"
                }, {
                    "imgUrl": "https://s21.lgstatic.com/growth/activity/20210910/1631257954730.png",
                    "storyImg": "https://s21.lgstatic.com/growth/activity/20210910/1631257962883.png"
                }, {
                    "imgUrl": "https://s20.lgstatic.com/growth/activity/20210910/1631257970116.png",
                    "storyImg": "https://s20.lgstatic.com/growth/activity/20210910/1631257978755.png"
                },
            ],
            "swiperList2": [
                "https://s21.lgstatic.com/growth/activity/20220607/1654586773867.png",
                "https://s21.lgstatic.com/growth/activity/20220607/1654586782592.png",
                "https://s21.lgstatic.com/growth/activity/20220607/1654586790469.png",
                "https://s21.lgstatic.com/growth/activity/20220607/1654586799039.png",
                "https://s20.lgstatic.com/growth/activity/20220607/1654586808764.png",
                "https://s21.lgstatic.com/growth/activity/20220607/1654586819734.png",
                "https://s20.lgstatic.com/growth/activity/20220607/1654586827220.png",
                "https://s21.lgstatic.com/growth/activity/20220607/1654586835960.png",
            ],
        },
        "pc": {
            "imgObj": {
                "top": "https://s21.lgstatic.com/growth/activity/20220315/1647312320380.png",
                "icon": "https://s20.lgstatic.com/growth/activity/20210831/1630391898890.png",
                "img1": "https://s20.lgstatic.com/growth/activity/20210913/1631502961686.png",
                "img2": "https://s20.lgstatic.com/growth/activity/20210913/1631502974994.png",
                "img3": "https://s21.lgstatic.com/growth/activity/20220315/1647313420253.png",
                "title1": "https://s20.lgstatic.com/growth/activity/20210913/1631514464099.png",
                "footer": "https://s21.lgstatic.com/growth/activity/20220426/1650954225781.png",
                "btn1": "https://s21.lgstatic.com/growth/activity/20210913/1631504514116.png",
                "btn2": "https://s21.lgstatic.com/growth/activity/20210913/1631513644784.png",
                "section1": "https://s21.lgstatic.com/growth/activity/20210913/1631521308164.png",
            },
            "imgList": [
                "https://s20.lgstatic.com/growth/activity/20210913/1631521124263.png",
                "https://s21.lgstatic.com/growth/activity/20210913/1631521136386.png",
                "https://s21.lgstatic.com/growth/activity/20210913/1631521153344.png",
                "https://s20.lgstatic.com/growth/activity/20210913/1631521165419.png",
                "https://s20.lgstatic.com/growth/activity/20210913/1631521174889.png",
            ],
            "imgList1": [
                "https://s21.lgstatic.com/growth/activity/20210913/1631521403628.png",
                "https://s20.lgstatic.com/growth/activity/20210913/1631521415955.png",
                "https://s20.lgstatic.com/growth/activity/20210913/1631521424836.png",
                // "https://s21.lgstatic.com/growth/activity/20210913/1631521433067.png"
            ],
            "swiperList": [
                "https://s20.lgstatic.com/growth/activity/20210913/1631521338171.png",
                "https://s20.lgstatic.com/growth/activity/20210913/1631521345434.png",
            ],
            "swiperList1": [
                "https://s20.lgstatic.com/growth/activity/20210913/1631515963559.png",
                "https://s20.lgstatic.com/growth/activity/20210913/1631515972184.png",
                "https://s21.lgstatic.com/growth/activity/20210913/1631515979303.png",
                "https://s21.lgstatic.com/growth/activity/20210913/1631515986252.png"
            ]

        },
        "tabList": [
            { "stage": "课程体系" },
            { "stage": "实战项目" },
            { "stage": "就业服务" },
            // { "stage": "私教模式" },
            // { "stage": "用户评价" },
        ],
        "stageList": [
            {
                "stage": "第一阶段",
                "title": "JavaScript 深度剖析",
                "phaseTargetList": [
                    "掌握 ES2016 - ES2021（ES7 - ES12）新特性、相关工具、迭代器模式",
                    "掌握使用 Babel 编译、Polyfill 等方案处理新特性环境兼容问题",
                    "理解单线程下的 JavaScript 异步模式执行机制，根治此类面试题",
                    "掌握 JavaScript 处理异步任务消息队列和事件循环，宏任务微任务",
                    "……等 9 项核心目标"
                ],
                "skillsList": [
                    "ECMAScript 新特性（ES6 - ES12）",
                    "新特性编译工具（Babel）",
                    "Polyfill：CoreJS 标准库",
                    "JavaScript 的同步与异步",
                    "异步任务消息队列与事件循环",
                    "……等 12 项关键技术"
                ],
                "details": [
                    {
                        "t": "阶段达成目标",
                        "desc": [
                            "充分掌握 ES2016 - ES2021（ES7 - ES12）新特性、相关工具、迭代器模式",
                            "掌握使用 Babel 编译、Polyfill 等方案处理新特性环境兼容问题",
                            "理解单线程下的 JavaScript 异步模式执行机制，根治此类面试题",
                            "掌握 JavaScript 处理异步任务的消息队列和事件循环，以及宏任务和微任务",
                            "理解 JavaScript 语言自有类型系统的不足以及相应的解决方案",
                            "掌握 TypeScript 基本语法、高级特性、内置标准库以及类型补充声明",
                            "掌握函数式编程范式，理解函数式思想，为深入源码学习做出铺垫",
                            "理解 JavaScript 中的内存管理机制、回收机制、相关算法",
                            "掌握 JavaScript 语言层面性能优化的 10 大优化细节"
                        ]
                    }, {
                        "t": "核心内容模块",
                        "desc": [
                            "ECMAScript 新特性（ES6 - ES12）",
                            "新特性编译工具（Babel）",
                            "Polyfill：CoreJS 标准库",
                            "JavaScript 的同步与异步",
                            "异步任务消息队列与事件循环",
                            "Flow 静态类型检查方案",
                            "TypeScript 高级编程、泛型、接口",
                            "TypeScript 标准库与类型补充",
                            "函数式编程范式",
                            "TypeScript 性能优化",
                            "TypeScript 内存机制与垃圾回收",
                            "引用计数、标记清除、整理和增量"
                        ]
                    }
                ]
            }, {
                "stage": "第二阶段",
                "title": "前端工程化实战",
                "phaseTargetList": [
                    "理解前端工程化定义及组成，对现代前端项目的重要性",
                    "理解脚手架工具设计思想和目标，掌握通用型工具使用及扩展",
                    "设计并开发一款符合自己企业个性化需求的脚手架工具",
                    "掌握自动化构建任务工具的使用，理解实现原理和扩展方式",
                    "……等 12 项核心目标"
                ],
                "skillsList": [
                    "前端工程化的组成",
                    "脚手架设计思想和目标",
                    "脚手架工作原理剖析",
                    "手写一个自己的脚手架工具：caz",
                    "自动化构建任务工具",
                    "……等 12 项关键技术"
                ],
                "details": [
                    {
                        "t": "阶段达成目标",
                        "desc": [
                            "理解前端工程化的定义及组成，以及对现代前端项目的重要性",
                            "理解脚手架工具的设计思想和目标，掌握通用型脚手架工具的使用及扩展",
                            "掌握如何设计并开发一款符合自己企业个性化需求的脚手架工具",
                            "掌握自动化构建任务工具的使用，理解其实现原理和扩展方式",
                            "掌握如何基于 Gulp 这类工具定制「傻瓜式」自动化工作流工具",
                            "掌握前端项目工作流中的自动化部署实现方式（CI/CD）",
                            "理解前端模块化的必要性以及模块化的发展演进过程（读史明智）",
                            "掌握使用 Webpack 实现前端项目整体模块化的实践方式",
                            "掌握 Webpack 最核心的 Loader 和 Plugin 机制，并能够开发自定义扩展",
                            "掌握 Webpack 中 Tree-shaking、sideEffects、CodeSplitting 等高级特性",
                            "掌握 Webpack 实现原理，手写实现 Webpack 核心源码",
                            "掌握前端规范化在企业开发中具体的落地方式及相应工具",
                        ]
                    }, {
                        "t": "核心内容模块",
                        "desc": [
                            "前端工程化的组成",
                            "脚手架设计思想和目标",
                            "脚手架工作原理剖析",
                            "手写一个自己的脚手架工具：caz",
                            "自动化构建任务工具",
                            "创建自动化构建工作流",
                            "封装独立的自动化构建工具",
                            "自动化部署（CI / CD）",
                            "持续集成与持续部署工具",
                            "模块化开发与 Webpack",
                            "手写 Webpack 源码，掌握原理",
                            "规范化标准与 ESLint"
                        ]
                    }, {
                        "t": "企业实战项目",
                        "desc": [
                            "CAZ - 基于模板机制的脚手架工具（京东前端团队在用）",
                            "X-pages - 集成式自动化工作流工具封装",
                            "Lgpack - 一比一还原 Webpack 内核源码"
                        ]
                    }
                ]
            }, {
                "stage": "第三阶段",
                "title": "Vue.js 框架源码与进阶",
                "phaseTargetList": [
                    "掌握 Vue Router、Vuex 等 Vue.js 生态下主要库的实现原理，手写源码",
                    "理解虚拟 DOM 机制，掌握 Diff 算法的实现原理及工作过程",
                    "理解 Vue.js 的整体实现过程、响应式机制、模板编译、组件实现机制",
                    "掌握如何开发符合企业个性化需求的 Vue.js 的组件库",
                    "……等 12 项核心目标"
                ],
                "skillsList": [
                    "手写 Vue Router 源码",
                    "数据响应式核心原理",
                    "虚拟 DOM 的目的及实现方式",
                    "Vue.js 2.6 核心源码剖析",
                    "Vuex 数据流管理方案",
                    "……等 12 项关键技术"
                ],
                "details": [
                    {
                        "t": "阶段达成目标",
                        "desc": [
                            "掌握 Vue Router、Vuex 等 Vue.js 生态下主要库的实现原理，手写源码",
                            "理解虚拟 DOM 机制，掌握 Diff 算法的实现原理及工作过程",
                            "理解 Vue.js 的整体实现过程、响应式机制、模板编译、组件实现机制",
                            "掌握如何开发符合企业个性化需求的 Vue.js 的组件库",
                            "掌握 Monorepo、Yarn workspace、Lerna、Storybook、Rollup、自动化测试",
                            "理解 CSR 存在的问题，了解 SSR 概念、优势及实现原理",
                            "掌握如何使用 Nuxt.js 快速实现 Vue.js 框架的 SSR 项目开发",
                            "掌握静态站点生成（SSG）方案及 Gridsome 框架",
                            "理解 Vue.js 3.0 的设计动机、Composition API，以及响应式原理",
                            "掌握基于 Bundleless 概念的 Vite 工具的使用及核心原理，手写源码实现",
                            "掌握基于 TypeScript 的 Vue.js 项目实战，掌握类型补充声明的使用",
                            "掌握如何搭建服务器生产环境（docker），能够独立部署完整前端项目",
                        ]
                    }, {
                        "t": "核心内容模块",
                        "desc": [
                            "手写 Vue Router 源码",
                            "数据响应式核心原理",
                            "虚拟 DOM 的目的及实现方式",
                            "Vue.js 2.6 核心源码剖析",
                            "Vuex 数据流管理方案",
                            "手写 Vuex 数据流框架",
                            "服务端渲染方案（RRS）及原理",
                            "Nuxt.js 集成式 SSR 框架与同构开发",
                            "自定义组件库开发与 Monorepo",
                            "Vue.js 3.0 设计动机与原则",
                            "快速掌握Composition APIs",
                            "Vue.js 3.0 核心源码剖析",
                        ]
                    }, {
                        "t": "企业实战项目",
                        "desc": [
                            "拉勾课堂管理平台 - 在线教育管理系统项目（Vue.js + Vuex + TypeScript）",
                            "Medium Clone 内容发布平台 - 内容讨论平台项目（Nuxt.js 实现 SSR）",
                            "基于 Docker 的前端自动化部署平台搭建",
                        ]
                    }
                ]
            }, {
                "stage": "第四阶段",
                "title": "React 框架原理与实战",
                "phaseTargetList": [
                    "掌握 React 设计思想及优势，理解为什么大厂更偏爱 React 技术栈",
                    "掌握 React 框架下的 Virtual DOM 实现原理与 Vue.js 框架的差异点",
                    "掌握 React 框架中的协调算法：Fiber、requestIdleCallback API",
                    "掌握大型 React 项目中不可避免的数据流管理方案：Redux 与 MobX",
                    "……等 12 项核心目标"
                ],
                "skillsList": [
                    "React 设计原理解密",
                    "React 框架核心源码解读",
                    "Redux 数据流管理方案",
                    "MobX 数据流管理方案",
                    "React Hooks 新特性",
                    "……等 12 项关键技术",
                ],
                "details": [
                    {
                        "t": "阶段达成目标",
                        "desc": [
                            "掌握 React 设计思想及优势，理解为什么大厂更偏爱 React 技术栈",
                            "掌握 React 框架下的 Virtual DOM 实现原理与 Vue.js 框架的差异点",
                            "掌握 React 框架中的协调算法：Fiber、requestIdleCallback API",
                            "掌握大型 React 项目中不可避免的数据流管理方案：Redux 与 MobX",
                            "理解 Redux 核心模块实现原理，掌握手写 Redux 核心模块源码",
                            "掌握 React 16.8 新增的 React Hooks 特性，理解 React Hooks 实现原理",
                            "掌握 CSS-in-JS 方案及常见的 CSS-in-JS 库：Emotion，理解 CSS-in-JS 思想",
                            "掌握社区中先进的 React CSS-in-JS 库：Chakra-UI",
                            "掌握 React 生态下的同构开发、 SSR 方案、Next.js 框架，SSG 方案、Gatsby 框架",
                            "掌握基于 TypeScript 的大型企业 React 项目搭建与开发",
                            "掌握 Angular 框架的实战开发，理解 Angular 框架的设计思想 *",
                            "掌握响应式状态管理库：RxJS，以及在 Angular 框架下的落地使用实践 *",
                        ]
                    }, {
                        "t": "核心内容模块",
                        "desc": [
                            "React 设计原理解密",
                            "React 框架核心源码解读",
                            "Redux 数据流管理方案",
                            "MobX 数据流管理方案",
                            "React Hooks 新特性",
                            "CSS-in-JS 方案与优势",
                            "Emotion 库及Chakra-UI 框架",
                            "React 服务端渲染（SSR）及原理",
                            "Next.js 集成式 SSR 框架",
                            "静态站点 SSG 方案及 Gatsby 框架",
                            "部署应用到 Vercel 平台（PaaS）",
                            "Angular 企业实战开发",
                        ]
                    }, {
                        "t": "企业实战项目",
                        "desc": [
                            "拉勾社交电影 - 基于 Next.js 的影视作品信息社区网站",
                            "Conduit Clone 内容发布平台 - 内容讨论平台 Gatsby 版（Gatsby、Strapi）",
                            "拉勾心选 - B2C 电商平台（React + Redux + Ant Design + TypeScript）"
                        ]
                    }
                ]
            }, {
                "stage": "第五阶段",
                "title": "Node.js 全栈开发",
                "phaseTargetList": [
                    "掌握 Node.js 平台下核心机制：非阻塞 IO、EventLoop、消息队列",
                    "掌握 Node.js 模块加载机制、第三方包机制、CommonJS 实现原理",
                    "掌握 Node.js 平台下网络编程、TCP/IP 协议、HTTP 服务搭建、Session 原理",
                    "掌握多进程 Node.js 应用开发以及 Node.js 集群搭建，结合 Nginx 反向代理服务",
                    "……等 12 项核心目标"
                ],
                "skillsList": [
                    "Node.js 高级编程",
                    "Node.js 模块加载原理",
                    "搭建反向代理服务器",
                    "NoSQL 数据库（MongoDB）",
                    "Redis 数据库及应用场景",
                    "……等 12 项关键技术"
                ],
                "details": [
                    {
                        "t": "阶段达成目标",
                        "desc": [
                            "掌握 Node.js 平台下核心机制：非阻塞 IO、EventLoop、消息队列",
                            "掌握 Node.js 模块加载机制、第三方包机制、CommonJS 实现原理",
                            "掌握 Node.js 平台下网络编程、TCP/IP 协议、HTTP 服务搭建、Session 原理",
                            "掌握多进程 Node.js 应用开发以及 Node.js 集群搭建，结合 Nginx 反向代理服务",
                            "掌握 MongoDB、Redis 数据库的使用及 BFF 层中数据库的应用",
                            "掌握基于 Express 框架快速开发 API 服务，以及 Koa 框架源码实现",
                            "掌握 BFF 层 RESTful 接口聚合方案，以及通过 GraphQL 标准提升 API 服务的可复用性",
                            "掌握阿里推出的 Egg.js 企业级 Node.js 框架",
                            "了解如何使用 Nest.js 框架构建高效且可伸缩的服务端应用",
                            "掌握面向切面编程、依赖注入的实践",
                            "掌握基于 Egg.js + Mongoose + Nunjucks + TypeScript 的企业级项目实践",
                            "掌握如何使用 Docker Compose + GitLab CI 自动化部署 Node.js 应用",
                        ]
                    }, {
                        "t": "核心内容模块",
                        "desc": [
                            "Node.js 高级编程",
                            "Node.js 模块加载原理",
                            "搭建反向代理服务器",
                            "NoSQL 数据库（MongoDB）",
                            "Redis 数据库及应用场景",
                            "Express Web 开发框架",
                            "Express 中间件机制实现原理",
                            "Koa 框架及手写源码实现",
                            "面向切面编程（AOP）",
                            "GraphQL API 规格及接口实现",
                            "Node.js 企业级开发框架 Egg.js",
                            "Nest.js 框架构建可伸缩服务",
                        ]
                    }, {
                        "t": "企业项目实战",
                        "desc": [
                            "RESTful 接口开发 - 基于 Node.js + Koa 的 API 服务接口（权限校验）",
                            "内容发布系统 - 基于 Node.js + Express + Handlebars 的 Web 前后端",
                            "Youtube Clone - 基于阿里 Egg.js 的中间层项目架构（TypeScript）",
                        ]
                    }
                ]
            }, {
                "stage": "第六阶段",
                "title": "泛客户端开发",
                "phaseTargetList": [
                    "掌握微信小程序原生开发，以及 MINA 框架结构",
                    "掌握 uni-app 多端统一开发解决方案、能够使用一套代码部署至所有移动平台",
                    "掌握基于 uni-app 的多媒体分享社区小程序项目开发",
                    "了解京东凹凸团队推出的 Taro 框架，理解其实现原理",
                    "……等 12 项核心目标"
                ],
                "skillsList": [
                    "小程序开发及 MINA 框架结构",
                    "uni-app 多框架端统一开发方案",
                    "京东 Taro 多端统一开发方案",
                    "混合式（Hybrid）APP 开发",
                    "通用型混合 APP 开发框架",
                    "……等 12 项关键技术"
                ],
                "details": [
                    {
                        "t": "阶段达成目标",
                        "desc": [
                            "掌握微信小程序原生开发，以及 MINA 框架结构",
                            "掌握 uni-app 多端统一开发解决方案、能够使用一套代码部署至所有移动平台",
                            "掌握基于 uni-app 的多媒体分享社区小程序项目开发",
                            "了解京东凹凸团队推出的 Taro 框架，理解其实现原理",
                            "掌握基于 H5 + 原生 WebView 的 Hybird App 开发方案，了解 JSBridge 通讯",
                            "掌握 React Native 技术方案，了解目前企业对 React Native 技术栈的落地方案",
                            "掌握 Dart 语言与 Dart 生态下的包管理机制",
                            "能够使用 Flutter 完成真正意义上的原生 APP 开发",
                            "掌握基于 Flutter 的在线教育 App 开发",
                            "掌握 Electron 整体架构，能够基于 Electron 使用 Web 技术开发桌面应用",
                            "掌握 Electron 应用的调试（主进程与渲染进程）以及相关工具（Spectron / Devtron）",
                            "掌握 Vue.js / React 这类框架在 Electron 平台下落地使用的最佳实践",
                        ]
                    }, {
                        "t": "核心内容模块",
                        "desc": [
                            "小程序开发及 MINA 框架结构",
                            "uni-app 多框架端统一开发方案",
                            "京东 Taro 多端统一开发方案",
                            "混合式（Hybrid）APP 开发",
                            "通用型混合 APP 开发框架",
                            "H5 与 Native 的双向通讯",
                            "React Native 跨平台 APP 开发",
                            "Dart 语言及 pubspec.yml",
                            "Flutter 跨端原生 APP 开发",
                            "Native 功能和 SDK 的调用",
                            "Electron 跨平台桌面应用开发",
                            "Electron 集成式打包工具",
                        ]
                    }, {
                        "t": "企业项目实战",
                        "desc": [
                            "柔宇星球 - 基于 ui-app 的跨平台信息分享小程序（已上线）",
                            "头条新闻 - 基于 React Native 的跨平台移动 APP 项目",
                            "拉勾课堂 APP - 基于 Flutter 的跨平台原生移动 APP 项目",
                        ]
                    }
                ]
            }, {
                "stage": "第七阶段",
                "title": "商业技术解决方案与高阶技术",
                "phaseTargetList": [
                    "了解 Serverless 无服务端架构方案的优势及发展趋势",
                    "掌握基于「腾讯云 / 阿里云」云函数的微服务开发",
                    "了解微前端架构诞生的背景以及所要解决的问题，理解实现思路",
                    "掌握基于 Single SPA 的微前端框架，以及 Webpack 5 最新推出的模块联邦特性",
                    "……等 11 项核心目标"
                ],
                "skillsList": [
                    "Serverless 无服务端架构方案",
                    "微前端架构与实践",
                    "长列表无限滚动优化方案",
                    "大数据可视化实现原理及相关框架",
                    "淘宝中途岛 / 中间层架构方案",
                    "……等 12 项关键技术"
                ],
                "details": [
                    {
                        "t": "阶段达成目标",
                        "desc": [
                            "了解 Serverless 无服务端架构方案的优势及发展趋势",
                            "掌握基于「腾讯云 / 阿里云」云函数的微服务开发",
                            "了解微前端架构诞生的背景以及所要解决的问题，理解实现思路",
                            "掌握基于 Single SPA 的微前端框架，以及 Webpack 5 最新推出的模块联邦特性",
                            "掌握企业级 App 中最常见的长列表无线滚动功能性能优化方案",
                            "掌握前端大数据展示、数据可视化框架 ECharts、AntV，以及 3D 可视化框架 Three.js",
                            "了解淘宝推出的基于 Node.js 的中途岛解决方案，掌握 BFF 架构",
                            "了解 PWA 渐进式 Web 应用开发方案、ServiceWorkers",
                            "掌握数据埋点系统设计、上报服务、客户端 SDK 封装",
                            "了解 Web 安全和前端应用性能解决方案",
                            "了解 Web Components 标准规范"
                        ]
                    }, {
                        "t": "核心内容模块",
                        "desc": [
                            "Serverless 无服务端架构方案",
                            "微前端架构与实践",
                            "长列表无限滚动优化方案",
                            "大数据可视化实现原理及相关框架",
                            "淘宝中途岛 / 中间层架构方案",
                            "PWA 渐进式 Web 应用开发",
                            "RBAC 权限管理及鉴权方案",
                            "接口 Mock 方案",
                            "OSS 云储存方案",
                            "H5 直播方案与 CDN 加速方案",
                            "HTTPS、XSS / CSRF、CSP",
                            "前端应用性能专题",
                        ]
                    }, {
                        "t": "企业项目实战",
                        "desc": [
                            "拉勾订单数据可视化看板 - 基于 ECharts 的大数据可视化平台",
                            "某浪新闻长列表无限滚动 - Vue.js 框架下的长列表虚拟滚动优化方案落地",
                            "JSON 可视化组件 - 基于 Web Components、Lit Element、Stencil",
                        ]
                    }
                ]
            }, {
                "stage": "第八阶段",
                "title": "大厂面试指导",
                "phaseTargetList": [
                    "狂扫 Leet Code 经典算法题，掌握前端常见数据结构与算法相关知识储备",
                    "全面拆解历年百度、阿里、腾讯、京东、头条、美团、滴滴经典前端面试题",
                    "面试专项能力突击，简历指导，一、二、三、四面注意事项及侧重点",
                    "大厂面试过程中屡试不爽的表达套路，学会在面试中更好的发挥应有水平",
                    "……等 9 项核心目标",
                ],
                "skillsList": [
                    "数据结构与算法基础",
                    "Leet Code 精选算法题",
                    "BATJ、TMD 高频面试真题",
                    "面试专项能力突击",
                    "面试过程发挥应有水平",
                    "……等 10 项关键技能",
                ],
                "details": [
                    {
                        "t": "阶段达成目标",
                        "desc": [
                            "狂扫 Leet Code 经典算法题，掌握前端常见数据结构与算法相关知识储备",
                            "全面拆解历年百度、阿里、腾讯、京东、头条、美团、滴滴经典前端面试题",
                            "面试专项能力突击，简历指导，一、二、三、四面注意事项及侧重点",
                            "大厂面试过程中屡试不爽的表达套路，学会在面试中更好的发挥应有水平",
                            "高分简历参考、1v1 重写简历，合理表达自己",
                            "掌握数据结构基础、了解常见前端算法",
                            "掌握 BATJ、TMD 常见面试题",
                            "轻松应对技术，人事，项目，leader 四面轰炸",
                            "了解前端行业技术发展趋势",
                        ]
                    }, {
                        "t": "核心内容模块",
                        "desc": [
                            "数据结构与算法基础",
                            "Leet Code 精选算法题",
                            "BATJ、TMD 高频面试真题",
                            "面试专项能力突击",
                            "面试过程发挥应有水平",
                            "打造一份让人无法拒绝的简历",
                            "前端行业技术前景展望",
                            "高级前端开发者的晋升通道",
                            "技术岗位周边技能的认知",
                            "打造属于自己的技术发声渠道",
                        ]
                    }
                ]
            }
        ]
    }
}